import MultipleQueryColumn from "query/MultipleQueryColumn";
import { Cell, CellType } from "table/Cell";
import { Row } from "table/Row";
import { CollectionExpanderIterator } from "./CollectionExpanderIterator";


export function expandRows(column: MultipleQueryColumn, source: Row[]): Row[] {
    let sink: Array<Row> = [];

    let c: Cell = new Cell(); // Only used to bootstrap the CollectionExpanderIterator.
    c._type = CellType.COLLECTION;
    c._value = source;
    let it = new CollectionExpanderIterator(column, 0);
    it.replenishWith(c);
    while (!it.isExhausted()) {
        let newRow = new Row(column);
        it.nextInto(newRow)
        sink.push(newRow);
        if (sink.length > 200) {
            console.warn("Stopping row expansion at 200 rows.");
            break;
        }
    }

    return sink;
}